import Component from '@glimmer/component'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import ContentTile from 'teacher-ui-client/components/tiles/content'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import type { PhosphorIconName } from 'phosphor-icons'

interface Args {
  theme?: ThemeKeys
  icon?: PhosphorIconName
  title: string
  tooltipTitle?: string
  detailedStudentReportRoute?: string
  detailStudentReportModels?: string[]
}

interface Signature {
  Element: Element
  Args: Args
  Blocks: {
    default: []
  }
}

const themes: Partial<Record<ThemeKeys, Record<PropertyKey, string>>> = {
  [ThemeKeys.blue]: { icon: 'text-oceany-blue-300 border-oceany-blue-150 print:text-black print:border-black' },
  [ThemeKeys.green]: { icon: 'text-ms-green-300 border-ms-green-150 print:text-black print:border-black' },
  [ThemeKeys.default]: { icon: 'text-black border-black' },
}

export class StudentDashboardTile extends Component<Signature> {
  get selectedTheme() {
    return themes[this.args.theme ?? ThemeKeys.default] ?? themes[ThemeKeys.default]
  }

  <template>
    <ContentTile data-test-student-dashboard-tile ...attributes>
      <div class="mx-3 my-2 flex flex-nowrap items-center justify-between">
        <div class="flex flex-nowrap items-center gap-3">
          {{#if @icon}}
            <div
              class="flex h-fit items-center justify-center border-2 p-0.5 {{this.selectedTheme.icon}}"
              data-test-tile-icon
            >
              <PhosphorIcon @icon={{@icon}} class="h-6 w-6" />
            </div>
          {{/if}}

          <h3 class="whitespace-nowrap" data-test-tile-title>{{@title}}</h3>

        </div>

        {{#if @tooltipTitle}}
          <span class="print:hidden" data-test-tile-tooltip>
            <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 cursor-pointer" />
            <Tooltip @text={{@tooltipTitle}} />
          </span>
        {{/if}}
        {{! nested 'if's to avoid glint errors from using 'and'}}
        {{#if @detailStudentReportModels}}
          {{#if @detailedStudentReportRoute}}
            <LinkTo
              data-test-tile-link
              class="inline-flex flex-nowrap items-center gap-1 font-semibold print:hidden"
              @route={{@detailedStudentReportRoute}}
              @models={{@detailStudentReportModels}}
            >
              {{t "reporting.seeMoreLink"}}
              <PhosphorIcon @icon="phosphor-arrow-circle-right-fill" class="h-5 w-5" />
            </LinkTo>
          {{/if}}
        {{else if @detailedStudentReportRoute}}
          <LinkTo
            data-test-tile-link
            class="inline-flex flex-nowrap items-center gap-1 font-semibold print:hidden"
            @route={{@detailedStudentReportRoute}}
          >
            {{t "reporting.seeMoreLink"}}
            <PhosphorIcon @icon="phosphor-arrow-circle-right-fill" class="h-5 w-5" />

          </LinkTo>
        {{/if}}
      </div>
      <div>
        {{yield}}
      </div>
    </ContentTile>
  </template>
}

export default StudentDashboardTile
